import styled from 'styled-components';
import bundleBackground from '../../../../images/Oval.svg';

const HeaderStyled = styled.div`
  background: #2d1540;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  display: flex;
  padding: 140px 25px 0;
  height: auto;
  margin: auto;
`;

const TitleStyled = styled.div`
  position: relative;
  text-align: center;
  margin: auto;
  padding-bottom: 40px;

  h1 {
    text-transform: uppercase;
    color: white;
    font-weight: 600;
    font-size: 23px;
    line-height: 26px;
  }
  h2 {
    color: #b3a6ba;
    font-weight: 300;
    font-size: 21px;
    line-height: 22px;
    > strong {
      font-weight: 500;
    }
  }
`;

const IconStyled = styled.div`
  width: 227.7px;
  height: 227.7px;
  border: 12px solid #e6e2e8;
  background: #fff;
  border-radius: 100%;
  top: 140px;
  margin: 0 auto;
  display: flex;
  align-items: center;

  > img {
    margin: 0 auto;
  }
`;

const IconHandStyled = styled.div`
  width: 227.7px;
  height: 227.7px;
  border: 12px solid #e6e2e8;
  background: #fff;
  border-radius: 100%;
  padding-left: 12px;
  top: 140px;
  margin: 0 auto;
  display: flex;
  align-items: center;

  > img {
    margin: 0 auto;
  }
`;

const ContainerStyled = styled.div`
  background: #e6e2e8;
  height: 100vh;
  padding-bottom: 100px;
`;

const ContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  min-height: max-content;
  position: relative;
`;

const LineCutStyled = styled.div`
  opacity: 0.41;
  border-top: 1.08px dashed #837390;
  margin: 25px 0;
  height: 1;
  width: 100%;
`;

const InformationWrapperStyled = styled.div`
  width: 370px;
  height: 100%;
  margin: 0 auto 38px;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  color: #2d1540;

  tr {
    > td {
      padding: 2px 5px;
      font-size: 15.12px;
      line-height: 21px;
      font-weight: 300;
      &:nth-child(1) {
        text-align: right;
        color: #2d1540;
      }

      &:nth-child(2) {
        text-align: left;
        color: #7c6c8a;
      }
    }
  }

  h3 {
    font-style: normal;
    font-weight: 900;
    font-size: 17.28px;
    line-height: 22px;
    text-align: center;
    color: #2d1540;
    margin-bottom: 12px;
  }
  ul {
    padding-left: 40px;
    padding-top: 40px;

    > li {
      > p {
        color: #7c6d89;
        padding: 15px 0px;
        font-size: 16px;
      }
    }
  }
`;

const DisclaimerStyled = styled.div`
  font-style: normal;
  font-weight: 900;
  font-size: 21.6px;
  line-height: 27px;
  text-align: center;
  margin-top: 15px;
  color: #2d1540;
  width: 350px;
  > span {
    font-style: normal;
    font-weight: normal;
    font-size: 17.28px;
    line-height: 26px;
    text-align: center;
    color: #7c6c8a;
  }
`;

const HeaderOvalStyled = styled.div`
  position: absolute;
  height: 175px;
  width: 100%;
  background-image: url(${bundleBackground});
  background-size: cover;
  background-position-y: bottom;
  background-position-x: center;
  margin-top: 160px;
`;

export {
  HeaderOvalStyled,
  HeaderStyled,
  ContentStyled,
  TitleStyled,
  ContainerStyled,
  IconStyled,
  IconHandStyled,
  InformationWrapperStyled,
  DisclaimerStyled,
  LineCutStyled,
};
